// src/pages/content/ContentCalendarPage.jsx
import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Paper,
  useTheme,
} from '@mui/material';
import {
  ViewDay as CalendarIcon,
  ViewList as ListIcon,
} from '@mui/icons-material';

// Import components
import ContentCalendar from '../../components/features/content/ContentCalendar';
import ContentList from '../../components/features/content/ContentList';

// Main Content Calendar Page component
const ContentCalendarPage = () => {
  const theme = useTheme();
  const location = useLocation();
  
  // Check if we're on a sub-route (detail, edit, create)
  const isSubRoute = location.pathname !== '/content' && location.pathname !== '/content/calendar';
  
  // Tab state
  const [tabValue, setTabValue] = useState(location.pathname === '/content/calendar' ? 0 : 1);
  
  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  
  // If we're on a sub-route, just render the outlet
  if (isSubRoute) {
    return <Outlet />;
  }
  
  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Content Management
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Create, manage, and schedule your content across multiple platforms.
        </Typography>
      </Box>
      
      <Paper sx={{ mb: 4 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="content view tabs"
          variant="fullWidth"
        >
          <Tab 
            label="Calendar View" 
            icon={<CalendarIcon />} 
            iconPosition="start" 
          />
          <Tab 
            label="List View" 
            icon={<ListIcon />} 
            iconPosition="start" 
          />
        </Tabs>
      </Paper>
      
      <Box sx={{ mt: 3 }}>
        {tabValue === 0 ? (
          <ContentCalendar />
        ) : (
          <ContentList />
        )}
      </Box>
    </Container>
  );
};

export default ContentCalendarPage;